// Persist the selected vehicle across pages (localStorage) so the customer's
// context follows them from Collections → Brand → PDP → Cart.

import { useEffect, useState } from "react";

const KEY = "uor_vehicle_v1";
const listeners = new Set();

const read = () => {
    if (typeof window === "undefined") return null;
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch { return null; }
};

const write = (val) => {
    if (val) localStorage.setItem(KEY, JSON.stringify(val));
    else localStorage.removeItem(KEY);
    listeners.forEach((l) => l());
};

export const vehicle = {
    set(brand) { write(brand); },   // { slug, name, tagline }
    clear() { write(null); },
    get() { return read(); },
};

export function useVehicle() {
    const [v, setV] = useState(read());
    useEffect(() => {
        const cb = () => setV(read());
        listeners.add(cb);
        return () => { listeners.delete(cb); };
    }, []);
    return v;
}
